import { ReactNode, lazy, Suspense } from 'react'

import { useCustomerHub } from '../contexts/CustomerHubContext'

// Dynamic imports for framer-motion to reduce initial bundle size
const LazyAnimatePresence = lazy(() =>
  import('framer-motion').then((mod) => ({ default: mod.AnimatePresence })),
)
const MotionDiv = lazy(() =>
  import('framer-motion').then((mod) => ({ default: mod.motion.div })),
)

// Animation configuration - hoisted to module scope
const initialAnimation = {
  opacity: 0,
  y: 20,
}

const exitAnimation = {
  opacity: 0,
}

const transitionConfig = {
  duration: 0.2,
  ease: 'easeOut',
} as const

interface AnimatedContentWrapperProps {
  children: ReactNode
  animationKey: string
  isPending?: boolean
}

export default function AnimatedContentWrapper({
  children,
  animationKey,
  isPending = false,
}: AnimatedContentWrapperProps) {
  const { disableAnimations } = useCustomerHub()

  if (disableAnimations) {
    return (
      <div className={`w-full${isPending ? ' opacity-50' : ''}`}>
        {children}
      </div>
    )
  }

  return (
    <Suspense fallback={<div className="w-full">{children}</div>}>
      <LazyAnimatePresence mode="wait" initial={false}>
        <MotionDiv
          key={animationKey}
          initial={initialAnimation}
          animate={{
            opacity: isPending ? 0.5 : 1,
            y: 0,
          }}
          exit={exitAnimation}
          transition={transitionConfig}
          className="w-full"
        >
          {children}
        </MotionDiv>
      </LazyAnimatePresence>
    </Suspense>
  )
}
